import { render, staticRenderFns } from "./woli-popup.vue?vue&type=template&id=56eb6b12&"
import script from "./woli-popup.vue?vue&type=script&lang=js&"
export * from "./woli-popup.vue?vue&type=script&lang=js&"
import style0 from "./woli-popup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports